export default {
  UPDATE_USER_CONTRACTS: 'UPDATE_USER_CONTRACTS',
  UPDATE_USER_CONTRACTS_SUCCESS: 'UPDATE_USER_CONTRACTS_SUCCESS',
  UPDATE_USER_CONTRACTS_FAILED: 'UPDATE_USER_CONTRACTS_FAILED',
  UPDATE_CONTRACT_LIST_SILENTLY: 'UPDATE_CONTRACT_LIST_SILENTLY',

  UPDATE_SELECTED_CONTRACT: 'UPDATE_SELECTED_CONTRACT',

  UPDATE_AGREEMENTS_LIST: 'UPDATE_AGREEMENTS_LIST',
  UPDATE_AGREEMENTS_LIST_SUCCESS: 'UPDATE_AGREEMENTS_LIST_SUCCESS',
  UPDATE_AGREEMENTS_LIST_FAILED: 'UPDATE_AGREEMENTS_LIST_FAILED',
  UPDATE_AGREEMENTS_LIST_SUCCESS_SILENTLY: 'UPDATE_AGREEMENTS_LIST_SUCCESS_SILENTLY',

  CLEAR_CONTRACT_INFO: 'CLEAR_CONTRACT_INFO',

  ACCEPT_AGREEMENT: 'ACCEPT_AGREEMENT',
  ACCEPT_AGREEMENT_SUCCESS: 'ACCEPT_AGREEMENT_SUCCESS',
  ACCEPT_AGREEMENT_FAILED: 'ACCEPT_AGREEMENT_FAILED',

  CREATE_CONTRACT: 'CREATE_CONTRACT',
  CREATE_CONTRACT_SUCCESS: 'CREATE_CONTRACT_SUCCESS',
  CREATE_CONTRACT_FAILED: 'CREATE_CONTRACT_FAILED',

};
